<template>
  <div>
    <button @click="show" type="button" class="btn btn-primary btn-sm mr-1">
      <font-awesome-icon icon="eye" />&nbsp;{{ $t('detail') }}
    </button>
    <b-modal v-model="showDetailModel" size="xl" ok-only :title="$t('calls')" modal-class="modal-fullscreen"
      content-class="modal-content-2" header-bg-variant="white" footer-bg-variant="white">

      <b-spinner v-if="loading" label="Loading..."></b-spinner>
      <template v-else-if="data">
        <div class="row tile m-2">
          <div class="col-6">
            <div v-if="data.client">
              <div><b>{{ $t('client') }}:</b> {{ data.client.companyName }}</div>
              <div><b>{{ $t('domain') }}:</b> {{ data.client.domain }}</div>
              <div v-if="!data.client.active"><b>{{ $t('status') }}:</b>
                <span class="badge badge-danger">
                  {{ $t('locked') }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-6 text-right">
            <button @click="del(data._id)" type="button"
              v-if="['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'am'].includes($store.state.user.role)"
              class="btn btn-danger mr-1">
              <font-awesome-icon icon="window-close" />&nbsp;{{ $t('skip') }}
            </button>
            <button @click="approved(data._id)" type="button"
              v-if="['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'am'].includes($store.state.user.role)"
              class="btn btn-warning mr-1">
              <font-awesome-icon icon="check" />&nbsp;{{ $t('lock') }}
            </button>
          </div>
        </div>
        <call-list v-if="model && model.client" :client="model.client" />
      </template>

      <template v-slot:modal-footer>
        <button class="btn btn-secondary" @click="showDetailModel = false">{{ $t('close') }}</button>
        <button @click="del(data._id)" type="button"
          v-if="['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'am'].includes($store.state.user.role)"
          class="btn btn-danger mr-1">
          <font-awesome-icon icon="window-close" />&nbsp;{{ $t('skip') }}
        </button>
        <button @click="approved(data._id)" type="button"
          v-if="['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'am'].includes($store.state.user.role)"
          class="btn btn-warning mr-1">
          <font-awesome-icon icon="check" />&nbsp;{{ $t('lock') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import CallList from "@/views/client/CallList.vue";

export default {
  props: ["id", 'model'],
  components: { CallList },
  data() {
    return {
      service: '/fault-detection-ip',
      showDetailModel: false,
      data: null,
      loading: true,
    }
  },
  methods: {
    approved: function (id) {
      this.$swal({
        title: this.$t('lockClient'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.$service.post(this.service + "/approved/" + id).then(response => {
            if (response.data) {
              this.$swal({
                title: this.$t('lockSuccess'),
                icon: 'success'
              });
              this.$bus.$emit("faultDetectionIP");
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                title: this.$t('error'),
                text: error.response.data.message,
                icon: 'error'
              });
            }
          })
        }
      })
    },
    del: function (id) {
      this.$swal({
        title: this.$t('deleteConfirm'),
        icon: "warning",
        showCancelButton: true
      }).then((result) => {
        if (result.isConfirmed) {
          let loader = this.$loading.show();
          this.$service.delete(this.service + '/' + id).then(response => {
            if (response.data) {
              this.showDetailModel = false;
              this.$bus.$emit("faultDetectionIP");
              this.$swal({
                title: this.$t('success'),
                text: this.$t('deleted'),
                icon: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('deleteFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    show() {
      if (this.id) {
        this.data = [];
        this.showDetailModel = true;
        this.loading = true;
        this.$service.get(`${this.service}/detail/${this.id}`).then(response => {
          if (response && response.data) {
            this.data = response.data;
          }
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
  i18n: {
    messages: {
      en: {
        skip: "Skip",
        lockClient: "Are you sure this customer is violating policy?",
        deleteConfirm: "Confirm the customer is not infringing",
        lockSuccess: "Confirm customer key, send notification email and notify admin",
        close: "Close",
        calls: "Calls",
      },
      vi: {
        skip: "Bỏ qua",
        lockClient: "Bạn chắc chắc xác định khách hàng này đang vi phạm chính sách?",
        deleteConfirm: "Xác nhận khách hàng không vi phạm, bỏ qua nghi ngờ?",
        lockSuccess: "Xác nhận khoá khách hàng, gửi email thông báo và thông báo đến admin",
        close: "Đóng",
        calls: "Danh sách cuộc gọi",
      }
    }
  }
}
</script>

<style>
.modal-fullscreen .modal-dialog {
  max-width: 98%;
}
</style>